// this is an autogenerated file from DesignSystem/GenerateLettersModal/Content/Letters/Letter/Template/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_GenerateLettersModal_Content_Letters_Letter_Template($org_id: uuid!) {
  documents_get_document_templates_for_org(args: { org_id: $org_id }) {
    id: _id
    text: name
  }
}

`